// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-btn[data-v-db96d88e]{max-width:50%!important}.bx--btn-set[data-v-db96d88e]{height:100%}.wizard-checkbox[data-v-db96d88e]{margin-left:16px}.error-notification[data-v-db96d88e]{position:absolute!important;right:0;top:0;height:unset}", ""]);
// Exports
module.exports = exports;
